import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-role-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.css']
})
export class UserViewComponent {

}
